// https://jaas.8x8.vc
// https://stackoverflow.com/questions/78317938/how-to-make-one-of-the-users-a-moderator-within-a-jitsi-meeting-using-jitsi-rea

import React, { 
  useState, 
  useEffect
} from 'react' 
import { useParams } from 'react-router-dom'
import { 
  useGame,
  useAvatar
} from 'data/hooks'
import {
  LoadingIndicator
} from 'basecomps'
import { JaaSMeeting } from '@jitsi/react-sdk'
import { fetch } from 'data/controls'
import { slugify } from 'commonutils/navigate'

export const Jitsi = props => {
    
  const params = useParams()
  
  const siteurl = playmotiv.siteurl
  const userId = playmotiv.user.id
  const gameId = params.gameId || playmotiv.game.gameId
  // const { avatar } = useAvatar(gameId, userId)
  const {
    game,
    events
  } = useGame(gameId)
  const avatar = useAvatar()

  const [ jaasjwt, setJaasJwt ] = useState()
  const [ roomtitle, setRoomtitle ] = useState()  

  const config = {
    SHOW_BRAND_WATERMARK: false,
    SHOW_WATERMARK_FOR_GUESTS: false,
    hiddenPremeetingButtons: [
      'select-background', 
      'invite', 
      'settings'
    ],
    toolbarButtons: [
      'fullscreen',
      'hangup',
      'microphone',
      'camera',
      'chat',
      // 'participants-pane',
      'desktop',
    ],
  }

  const interfaceConfig = {
    SHOW_JITSI_WATERMARK: false
  }

  useEffect(() => {

    const planet = events[params.planetId]
    const event = events[params.eventId]

    const roomtitle = slugify(
      game.title + ' - ' + 
      planet.title + ' - ' + 
      event.title
    )
  
    setRoomtitle(roomtitle)
    
    fetch(
      '/jitsi/jassjwt', 
      {
        method: 'POST',
        body: {
          userid: userId,
          email: playmotiv.user.email,
          username: playmotiv.user.displayname,
          ismoderator: false,
          room: roomtitle
          // avatarurl: siteurl + avatar
        } 
      },
      'core'
    )
    .then(response => {

      setJaasJwt(response)
    })

  }, [])

  return (
    <div 
      className={`
        shortcode jitsi
      `}
    >
      <div className="loading">
        Creando sala "{ roomtitle }"...
      </div>
      {
        jaasjwt &&
        roomtitle &&
        <JaaSMeeting 
          appId={ jaasjwt.appid }
          roomName={ roomtitle }
          jwt={ jaasjwt.token }
          spinner = { LoadingIndicator }
          configOverwrite={ config }
          interfaceConfigOverwrite={ interfaceConfig }
        />
      }
    </div>
  )
}